import { Foundation } from 'foundation-sites/js/foundation.core';
import { Reveal } from 'foundation-sites/js/foundation.reveal';
import queryString from 'query-string';
import { tryFetch, getAssetLink } from '../helpers/api';
import { Italian } from 'multiple-select-vanilla/dist/locales/multiple-select-it-IT';
import { English } from 'multiple-select-vanilla/dist/locales/multiple-select-en-US';
import { German } from 'multiple-select-vanilla/dist/locales/multiple-select-de-DE';
import { French } from 'multiple-select-vanilla/dist/locales/multiple-select-fr-FR';
import { multipleSelect } from 'multiple-select-vanilla';
import I18n from '../helpers/i18n';
import { translations } from '../translations/translations';

export class ProductList {
  constructor(target) {
    this.section = target;

    this.form = this.section.querySelector('#filters');
    this.sidebarForm = this.section.querySelector('#sidebar-filters');
    this.mainFiltersWrapper = this.section.querySelector('.main-product-filters');
    this.sidebarFiltersWrapper = this.section.querySelector('.sidebar-product-filters');
    this.sidebarSubmitButton = this.section.querySelector('.filters-modal-footer .submit-sidebar-filters');
    this.brand = this.form?.getAttribute('data-brand');
    this.category = this.form?.getAttribute('data-category');
    this.categoryIcon = this.form?.getAttribute('data-category-icon');
    this.totalLabel = this.section.querySelectorAll('[data-total]');
    this.mainGrid = this.section.querySelector('.main-grid [data-list]');
    this.loadMoreBtn = this.section.querySelector('[data-load-more]');
    this.preventChangeAction = false;
    this.areFiltersSyncing = false;
    this.detailsUrl = this.section?.dataset?.detailsUrl || '';
    this.openedMainFilters = {};
    this.openedSidebarFilters = {};

    this.filters = {
      brand: this.brand,
      category: this.category,
      limit: 12,
      page: 1,
      offset: 0,
      lang: document.documentElement.lang || 'en'
    };

    this.response = null;

    this.i18n = new I18n(translations.productList);
  }

  init() {
    this.loading(false);
    // eslint-disable-next-line
    $ = Foundation.addToJquery($);
    Foundation.plugin(Reveal, 'Reveal');

    if (!this.form || !this.sidebarForm) {
      return;
    }

    this.initMultipleSelect();
    this.initSidebarMultipleSelect();
    this.initFilters();
    this.initSidepanel();
  }

  initSidepanel() {
    $('#product-list-filters-modal').foundation();
  }

  initFilters() {
    this.getSelectedFilters();
    this.onFiltersChipClick();
    this.onFiltersReset();
    this.onFiltersChange();
    this.onSidebarFiltersChange();
    this.onSidebarFiltersSubmit();
    this.onLoadMore();
  }

  loading(isLoading = true) {
    this.section.classList.toggle('loading', isLoading);
  }

  getSelectedFilters() {
    const sidebarFiltersElements = this.sidebarForm.querySelectorAll('select.multiple-select');

    sidebarFiltersElements.forEach(element => {
      const filterName = element.getAttribute('name');
      const filter = `filters[${filterName}]`;
      const values = this.getMultiSelectValue(element);

      this.filters[filter] = values;
    })
  }

  onFiltersChipClick() {
    this.selectedValues = this.section.querySelector('[data-selected-values]');

    this.selectedValues.addEventListener('click', async (e) => {
      const buttonWrapper = e.target.closest('button');

      if (buttonWrapper) {
        const filterName = buttonWrapper.dataset.removeFromFilter;
        const itemValue = buttonWrapper.dataset.removeItem;
        const filterSelect = this.form.querySelector(`[name="${filterName}"]`);
        const sidebarFilterSelect = this.sidebarForm.querySelector(`[name="${filterName}"]`);

        if (filterSelect) {
          filterSelect._multipleSelect.uncheck(itemValue);
        }

        if (sidebarFilterSelect) {
          sidebarFilterSelect._multipleSelect.uncheck(itemValue);
        }

        await this.afterFiltersChange();
      }
    });
  }

  onFiltersReset() {
    this.filtersElements = this.form.querySelectorAll('select.multiple-select');
    this.sidebarFiltersElements = this.sidebarForm.querySelectorAll('select.multiple-select');

    this.form.addEventListener('reset', async () => {
      this.preventChangeAction = true;

      this.filtersElements.forEach(filter => {
        filter._multipleSelect.uncheckAll();
      });

      this.sidebarFiltersElements.forEach(filter => {
        filter._multipleSelect.uncheckAll();
      });

      this.preventChangeAction = false;

      await this.afterFiltersChange();
    });
  }

  onFiltersChange() {
    this.filtersElements = this.form.querySelectorAll('select.multiple-select');

    this.filtersElements.forEach((element) => {
      element.addEventListener('change', async (event) => {
        const selectElement = event.target;

        await this.syncFilters(selectElement, this.sidebarForm);
      });
    });
  }

  onSidebarFiltersChange() {
    this.sidebarFiltersElements = this.sidebarForm.querySelectorAll('select.multiple-select');

    this.sidebarFiltersElements.forEach((element) => {
      element.addEventListener('change', async (event) => {
        const targetElement = event.target;
        const filterName = targetElement.getAttribute('name');
        const filter = `filters[${filterName}]`;
        const values = this.getMultiSelectValue(targetElement);

        this.filters[filter] = values;

        await this.getData();

        this.prepareHTMLSidebarFilters();
        this.renderSidebarFilters();
        this.onSidebarFiltersChange();

        if (this.sidebarSubmitButton) {
          const sidebarSubmitButtonResults = this.sidebarSubmitButton.querySelector('.results-number');

          sidebarSubmitButtonResults.innerHTML = this.response.total;
        }
      });
    });
  }

  onSidebarFiltersSubmit() {
    this.sidebarSubmitButton.addEventListener('click', () => {
      this.sidebarFiltersElements = this.sidebarForm.querySelectorAll('select.multiple-select');
      this.preventChangeAction = true;

      this.sidebarFiltersElements.forEach(async (element) => {
        await this.syncFilters(element, this.form);
      })

      this.preventChangeAction = false;

      this.afterFiltersChange();
    })
  }

  async syncFilters(sourceElement, target) {
    if (!this.areFiltersSyncing) {
      this.areFiltersSyncing = true;

      const filterName = sourceElement.getAttribute('name');
      const filter = `filters[${filterName}]`;
      const values = this.getMultiSelectValue(sourceElement);

      this.filters[filter] = values;

      const targetFilter = target.querySelector(`[name="${filterName}"]`);

      if (targetFilter) {
        targetFilter._multipleSelect.setSelects(values)
      }

      if (this.preventChangeAction) {
        this.areFiltersSyncing = false;

        return;
      }

      this.filters.page = 1;

      await this.afterFiltersChange();

      this.areFiltersSyncing = false;
    }
  }

  onLoadMore() {
    this.loadMoreBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      this.filters.page += 1;

      await this.afterFiltersChange();
    });
  }

  async afterFiltersChange() {
    this.pushToHistory();
    await this.getData();
    this.prepareHTMLProducts();
    this.prepareHTMLMainFilters();
    this.prepareHTMLSidebarFilters();
    this.renderSelectedValues();

    if (this.filters.page === 1 && this.response?.products?.length) {
      this.renderFirstPage();
    }

    if (this.filters.page === 1 && !this.response?.products?.length) {
      this.renderNoResults();
    }

    if (this.filters.page > 1 && this.response?.products?.length) {
      this.renderConsequentPage();
    }

    this.renderMainFilters();
    this.renderSidebarFilters();
    this.onFiltersChange();
    this.onSidebarFiltersChange();

    this.handlePagination();
    this.handleFiltersVisibility();
    this.toggleFiltersSummary();
  }

  initMultipleSelect() {
    const localeMap = {
      it: Italian,
      en: English,
      de: German,
      fr: French
    };

    this.form.querySelectorAll('.multiple-select').forEach((el) => {
      multipleSelect(el, {
        locale: localeMap[document.documentElement.lang || 'en'],
        filter: el.dataset.filter || false,
        showClear: el.dataset.showClear || false,
        selectAll: false,
        onOpen: () => {
          const selectName = el?.name;

          if (el?.name) {
            this.openedMainFilters[selectName] = true;
          }
        },
        onClose: () => {
          const selectName = el?.name;

          if (selectName) {
            this.openedMainFilters[selectName] = false;
          }
        },
      });

      if (this.openedMainFilters[el?.name]) {
        el?._multipleSelect.open()
      }
    });
  }

  initSidebarMultipleSelect() {
    const localeMap = {
      it: Italian,
      en: English,
      de: German,
      fr: French
    };

    this.sidebarForm.querySelectorAll('select.multiple-select').forEach((el) => {
      multipleSelect(el, {
        locale: localeMap[document.documentElement.lang || 'en'],
        filter: el.dataset.filter || false,
        showClear: el.dataset.showClear || false,
        selectAll: false,
        onOpen: () => {
          const selectName = el?.name;

          if (el?.name) {
            this.openedSidebarFilters[selectName] = true;
          }
        },
        onClose: () => {
          const selectName = el?.name;

          if (selectName) {
            this.openedSidebarFilters[selectName] = false;
          }
        },
      });

      if (this.openedSidebarFilters[el?.name]) {
        el?._multipleSelect.open()
      }
    });
  }

  renderSelectedValues() {
    this.totalLabel.forEach(el => {
      el.innerHTML = `${this.response.total} risultati`;
    });

    const HTMLSelectedFilters = this.customFiltersSort(this.response.filters).map((filter) => {
      const isAnyValueSelected = filter?.values?.some((value) => value.selected);
      let HTMLFilterValues = [];

      if (isAnyValueSelected) {
        HTMLFilterValues = filter.values.map((filterValue) =>
          (filterValue?.selected
            ? `
          <li>
            <span class="chip deletable">
              ${filterValue?.displayValue ? filterValue?.displayValue : filterValue?.value}
              <button type="button" data-remove-item="${filterValue?.value}" data-remove-from-filter=${filter?.name}>
                <svg width="10" height="10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 1L1 19" stroke="black" stroke-width="3" stroke-linejoin="round"/>
                  <path d="M1 1L19 19" stroke="black" stroke-width="3" stroke-linejoin="round"/>
                </svg>
              </button>
            </span>
          </li>
        `
            : '')
        );
      }

      return isAnyValueSelected
        ? `
        <div class="chip-group">
          <span class="group-title">${filter.displayName ? filter.displayName : filter.name}</span>
          <ul class="chip-list">
            ${HTMLFilterValues.join('')}
          </ul>
        </div>
      `
        : '';
    });

    const HTMLSelectedFiltersFinished = HTMLSelectedFilters.join('');

    this.selectedValues.innerHTML = '';
    this.selectedValues.innerHTML = HTMLSelectedFiltersFinished;
  }

  handlePagination() {
    const isLastPage = this.response.offset + this.response.limit >= this.response.total;

    this.loadMoreBtn.classList.toggle('hide', isLastPage);
  }

  handleFiltersVisibility() {
    const isAnyFilter = this.response?.filters?.length;

    if (!isAnyFilter) {
      this.form.classList.add('hide')
    }
  }

  toggleFiltersSummary () {
    const selectedFilters = this.section.querySelectorAll('[data-selected-values] .chip');
    const isAnyFilterSelected = Boolean(selectedFilters.length);

    this.section.classList.toggle('filters-active', isAnyFilterSelected);
  }

  renderNoResults() {
    const isAnyProduct = this.response?.total;

    this.mainGrid.innerHTML = '';
    this.mainGrid.innerHTML = `
      <div class="product-list-empty text-center">
        <p>${this.i18n.get('noProductsFound')}</p>
        <p>${this.i18n.get('clearFilters')}</p>
      </div>
    `;

    if (isAnyProduct) {
      this.totalLabel.forEach(el => {
        el.classList.add('hide');
      })
    }
  }

  renderFirstPage() {
    this.mainGrid.innerHTML = '';
    this.mainGrid.innerHTML = this.HTMLProducts.join('');
  }

  renderConsequentPage() {
    this.mainGrid.insertAdjacentHTML('beforeend', this.HTMLProducts.join(''));
  }

  renderMainFilters() {
    this.form.querySelectorAll('.multiple-select').forEach((el) => {
      el?._multipleSelect?.destroy();
      el._multipleSelect = undefined;
    });

    this.mainFiltersWrapper.innerHTML = '';
    this.mainFiltersWrapper.innerHTML = this.HTMLMainFilters.join('');

    this.initMultipleSelect();
  }

  renderSidebarFilters() {
    this.sidebarForm.querySelectorAll('.multiple-select').forEach((el) => {
      el?._multipleSelect?.destroy();
      el._multipleSelect = undefined;
    });

    this.sidebarFiltersWrapper.innerHTML = '';
    this.sidebarFiltersWrapper.innerHTML = this.HTMLSidebarFilters.join('');

    this.initSidebarMultipleSelect();
  }

  pushToHistory() {
    const params = new URLSearchParams(document.location.search);
    const category = params.get('category');
    const queryParams = {
      category,
      page: this.filters.page
    };

    for (const key in this.filters) {
      if (key.startsWith('filters[')) {
        queryParams[key] = this.filters[key];
      }
    }

    const qs = queryString.stringify(queryParams, {
      arrayFormat: 'separator',
      arrayFormatSeparator: ','
    });

    window.history.pushState(this.filters, '', `?${qs}`);
  }

  getMultiSelectValue(target) {
    return target?._multipleSelect?.data?.filter((el) => el.selected)?.map((el) => el.value) || [];
  }

  async getData() {
    const APIQueryParams = { ...this.filters };

    APIQueryParams.offset = this.pageToOffset(this.filters.page);
    delete APIQueryParams.page;

    const params = queryString.stringify(APIQueryParams, {
      arrayFormat: 'none'
    });

    const API_URL = `${CMS.contextPath}/.rest/delivery/products?${params}`;
    const [response] = await tryFetch(API_URL);

    this.response = response;
  }

  getColors(product) {
    if (!product.customFields || !product.customFields.some((field) => field.name === 'color')) {
      return '';
    }

    const colors = product.customFields.find((field) => field.name === 'color').values;
    const colorsElementsHTML = colors
      .map(
        (color) => {
          const colorCode = color.hexValue;

          return `
            <div
              class="color-box"
              style="background: ${colorCode}; border-color: ${colorCode}">
            </div>
          `;
        }
      )
      .join('');
    const colorsHTML = `
      <div class="color-row">
        ${colorsElementsHTML}
      </div>
    `;

    return colorsHTML;
  }

  prepareHTMLProducts() {
    if (!this.response?.products?.length) {
      return;
    }

    this.HTMLProducts = this.response.products.map((product) => {
      const productUrl = `${this.detailsUrl}/${product?.uuid}.html`;
      const productline = product?.customFields?.find(field => field.name === 'line')?.values[0];
      const productLabel = productline ? (productline.displayName ? productline.displayName : productline.name) : '';
      const productName = product.displayName ? product.displayName : product.name;
      const newProductTag = product.newProduct ? `
        <div class="product-tag-new">
          NEW
        </div>
      ` : '';
      const colors = this.getColors(product);
      const categoryIconStyles = `
        mask: url('${this.categoryIcon}') no-repeat center / contain;
        -webkit-mask: url('${this.categoryIcon}') no-repeat center / contain
      `;
      const categoryIconHTML = this.categoryIcon
        ? `
        <div class="product-icon-wrapper">
          <div class="icon-mask" style="${categoryIconStyles}"></div>
        </div>
      `
        : '';

      return `
        <div class="small-6 large-4 columns">
          <div class="product-card ${this.brand.toLowerCase()}">
            ${newProductTag}
            <img
              src="${product.image ? getAssetLink(product.image, 'medium') : ''}"
              class="product-image"
              alt="product image">
            <span class="product-label">${productLabel}</span>
            <a href="${productUrl}" class="product-name">${productName}</a>
            ${colors}
            <div class="details-row">
              ${categoryIconHTML}
              <a class="product-link" href="${productUrl}">
                <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9 1.65625L7.95 2.70625L12.15 6.90625H0V8.40625H12.15L7.95
                      12.6063L9 13.6562L15 7.65625L9 1.65625Z"
                    fill="currentColor"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      `;
    });
  }

  prepareHTMLMainFilters() {
    if (!this.response?.products?.length || !this.response?.filters?.length) {
      return;
    }

    this.HTMLMainFilters = this.customFiltersSort(this.response.filters)
      .filter((filter) => filter?.mainFilter)
      .map((filter) => {
        const options = filter.values
          .map((item) => `
            <option value="${item.value}" ${item.selected ? 'selected' : ''}>
              ${item.displayValue ? item.displayValue : item.value}
            </option>
          `).join('');

        return `
          <label>
            <select
              multiple="multiple"
              class="multiple-select js-rendered"
              placeholder="${filter.displayName ? filter.displayName : filter.name}"
              name="${filter.name}">
              ${options}
            </select>
          </label>
        `;
      });
  }

  prepareHTMLSidebarFilters() {
    if (!this.response?.products?.length || !this.response?.filters?.length) {
      return;
    }

    const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

    this.HTMLSidebarFilters = this.customFiltersSort(this.response.filters).map((filter) => {
      const options = filter.values
        .map((item) => `
          <option value="${item.value}" ${item.selected ? 'selected' : ''}>
            ${item.displayValue ? item.displayValue : item.value}
          </option>
        `).join('');

      return `
        <label class="sidebar-select-accordion-item">
          <span class="accordion-item-title">
            ${filter.displayName ? filter.displayName : capitalize(filter.name)}
          </span>
          <select
            multiple="multiple"
            class="multiple-select"
            name="${filter.name}"
            data-keep-open="true"
            >
            ${options}
          </select>
        </label>
      `;
    });
  }

  pageToOffset(pageNumber = 1, pageSize = 12) {
    return (pageNumber - 1) * pageSize;
  }

  // TODO this is temporary solution, results should be always in same order
  customFiltersSort(arr) {
    const priorityOrder = ['line', 'flap', 'saddleTree', 'seatWidth', 'seatDepth'];

    arr.sort((a, b) => {
        const indexA = priorityOrder.indexOf(a.name);
        const indexB = priorityOrder.indexOf(b.name);

        if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
        }

        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;

        return a.name.localeCompare(b.name);
    });

    return arr;
  }
}
